export default __webpack_public_path__ + "static/media/e2d6a323a0da8c7e70aaf64bced1252b.jpg";